import { useState } from 'react';

const steps = [
  {
    number: 1,
    title: 'APK herunterladen',
    desc: 'Tippen Sie auf den Download-Button. Die Datei wird automatisch in Ihrem Download-Ordner gespeichert.',
    icon: <path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />,
    tip: 'Die Datei heißt samoplan.apk und ist ca. 25 MB groß.',
  },
  {
    number: 2,
    title: 'Installation erlauben',
    desc: 'Ihr Gerät fragt, ob Apps aus unbekannten Quellen installiert werden dürfen. Tippen Sie auf „Einstellungen" und aktivieren Sie den Schalter.',
    icon: <><path d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></>,
    tip: 'Pfad: Einstellungen → Sicherheit → Unbekannte Quellen → Erlauben',
  },
  {
    number: 3,
    title: 'App installieren',
    desc: 'Öffnen Sie die heruntergeladene Datei und tippen Sie auf „Installieren". Die Installation dauert wenige Sekunden.',
    icon: <path d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />,
    tip: null,
  },
  {
    number: 4,
    title: 'Anmelden & loslegen',
    desc: 'Öffnen Sie samoPlan, geben Sie Ihre Zugangsdaten ein (E-Mail + Passwort vom Admin) — fertig. Die App funktioniert sofort, auch ohne Internet.',
    icon: <path d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />,
    tip: 'Tipp: Legen Sie Nutzer vorher im Büro an unter Einstellungen → Nutzer.',
  },
];

const highlights = [
  {
    title: 'Komplett offline-fähig',
    desc: 'Kein WLAN auf der Baustelle? Kein Problem. Alle Funktionen laufen lokal auf dem Tablet. Zeiteinträge, Fotos, Berichte — alles wird gespeichert und automatisch synchronisiert, sobald wieder Netz da ist.',
    icon: <><path d="M8.111 16.404a5.5 5.5 0 017.778 0M12 20h.01m-7.08-7.071c3.904-3.905 10.236-3.905 14.14 0M1.394 9.393c5.857-5.858 15.355-5.858 21.213 0" /></>,
    color: 'from-emerald-500 to-teal-500',
    bg: 'bg-emerald-50',
    text: 'text-emerald-600',
  },
  {
    title: 'Baustellenkamera',
    desc: 'Fotos direkt aufnehmen, automatisch dem Projekt zuordnen, mit GPS-Koordinaten versehen. Nie wieder Bilder manuell sortieren oder per WhatsApp verschicken.',
    icon: <><path d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" /><path d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" /></>,
    color: 'from-brand-500 to-purple-500',
    bg: 'bg-brand-50',
    text: 'text-brand-600',
  },
  {
    title: 'Zeiterfassung in Sekunden',
    desc: 'Ein Tipp — Timer läuft. Projekt auswählen, Pause drücken, Feierabend stoppen. Einfacher geht es nicht. Funktioniert auch im tiefsten Funkloch.',
    icon: <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />,
    color: 'from-amber-500 to-orange-500',
    bg: 'bg-amber-50',
    text: 'text-amber-600',
  },
  {
    title: 'Digitale Bauberichte',
    desc: 'Tagesberichte direkt auf dem Tablet: Wetter, ausgeführte Arbeiten, Arbeitskräfte, Fotos anhängen, digital unterschreiben — alles rechtskonform dokumentiert.',
    icon: <><path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></>,
    color: 'from-violet-500 to-purple-500',
    bg: 'bg-violet-50',
    text: 'text-violet-600',
  },
  {
    title: 'Sofort synchronisiert',
    desc: 'Sobald das Tablet wieder online ist, werden alle Daten automatisch ins Büro übertragen. Kein USB-Kabel, kein manueller Export, kein Datenverlust.',
    icon: <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />,
    color: 'from-cyan-500 to-blue-500',
    bg: 'bg-cyan-50',
    text: 'text-cyan-600',
  },
  {
    title: 'Robust & sicher',
    desc: 'Optimiert für den Baustellenalltag. Lokale Datenspeicherung schützt vor Datenverlust. Verschlüsselte Übertragung (TLS). DSGVO-konform auf deutschen Servern.',
    icon: <><path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></>,
    color: 'from-slate-500 to-slate-600',
    bg: 'bg-slate-50',
    text: 'text-slate-600',
  },
];

const devices = [
  { name: 'Wortmann Terra PAD 1007', screen: '10.1"', android: '11+', status: 'Empfohlen' },
  { name: 'Wortmann Terra PAD 1201', screen: '12.1"', android: '12+', status: 'Empfohlen' },
  { name: 'Wortmann Terra PAD 1200V2', screen: '12.0"', android: '12+', status: 'Empfohlen' },
  { name: 'Samsung Galaxy Tab (alle)', screen: 'Versch.', android: '11+', status: 'Kompatibel' },
  { name: 'Andere Android-Tablets', screen: 'Versch.', android: '11+', status: 'Kompatibel' },
];

const stats = [
  { value: '100%', label: 'Offline-fähig', sub: 'Kein WLAN nötig' },
  { value: '<5s', label: 'Sync-Zeit', sub: 'Wenn wieder online' },
  { value: '25MB', label: 'App-Größe', sub: 'Schnell installiert' },
  { value: '0 €', label: 'Extra-Kosten', sub: 'Im Abo enthalten' },
];

export default function DownloadPage() {
  const [activeStep, setActiveStep] = useState<number | null>(null);
  const [copied, setCopied] = useState(false);
  const downloadUrl = '/api/v1/download/samoplan.apk';
  const appUrl = window.location.origin + '/download';

  const copyLink = () => {
    navigator.clipboard.writeText(appUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="max-w-5xl mx-auto">

      {/* ═══ HERO ═══ */}
      <div className="sp-card overflow-hidden mb-8 animate-fade-in">
        <div className="relative bg-gradient-to-br from-brand-600 via-brand-500 to-purple-600 p-10">
          {/* Animated background shapes */}
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute -top-10 -right-10 w-64 h-64 rounded-full bg-white/[0.04] animate-float" />
            <div className="absolute top-20 right-20 w-32 h-32 rounded-full bg-white/[0.06] animate-float" style={{ animationDelay: '1.5s' }} />
            <div className="absolute -bottom-8 -left-8 w-48 h-48 rounded-full bg-white/[0.03] animate-float" style={{ animationDelay: '3s' }} />
            <div className="absolute top-8 left-1/2 w-16 h-16 rounded-2xl bg-white/[0.05] rotate-12 animate-float" style={{ animationDelay: '2s' }} />
          </div>

          <div className="relative flex items-start gap-8">
            {/* Tablet mockup */}
            <div className="flex-shrink-0 animate-scale-in">
              <div className="w-[180px] h-[240px] rounded-3xl bg-slate-900 p-2 shadow-2xl ring-1 ring-white/10 rotate-[-2deg] hover:rotate-0 transition-transform duration-500">
                <div className="w-full h-full rounded-2xl bg-gradient-to-b from-slate-800 to-slate-900 flex flex-col overflow-hidden">
                  {/* Status bar */}
                  <div className="h-5 bg-brand-700/50 flex items-center justify-between px-3">
                    <span className="text-[6px] text-white/60 font-medium">samoPlan</span>
                    <div className="flex items-center gap-1">
                      <div className="w-2 h-1.5 rounded-sm border border-white/40" />
                      <span className="text-[6px] text-white/60">100%</span>
                    </div>
                  </div>
                  {/* App content mockup */}
                  <div className="flex-1 p-2.5 space-y-2">
                    <div className="h-3 bg-white/10 rounded-full w-2/3" />
                    <div className="h-2 bg-white/5 rounded-full w-full" />
                    <div className="grid grid-cols-2 gap-1.5 mt-2">
                      <div className="h-14 rounded-lg bg-brand-500/30 p-1.5">
                        <div className="w-4 h-4 rounded bg-brand-400/50 mb-1" />
                        <div className="h-1.5 bg-white/10 rounded-full w-3/4" />
                      </div>
                      <div className="h-14 rounded-lg bg-emerald-500/30 p-1.5">
                        <div className="w-4 h-4 rounded bg-emerald-400/50 mb-1" />
                        <div className="h-1.5 bg-white/10 rounded-full w-3/4" />
                      </div>
                      <div className="h-14 rounded-lg bg-amber-500/30 p-1.5">
                        <div className="w-4 h-4 rounded bg-amber-400/50 mb-1" />
                        <div className="h-1.5 bg-white/10 rounded-full w-3/4" />
                      </div>
                      <div className="h-14 rounded-lg bg-purple-500/30 p-1.5">
                        <div className="w-4 h-4 rounded bg-purple-400/50 mb-1" />
                        <div className="h-1.5 bg-white/10 rounded-full w-3/4" />
                      </div>
                    </div>
                    {/* Offline badge */}
                    <div className="flex items-center gap-1 bg-emerald-500/20 rounded-full px-2 py-1 w-fit">
                      <div className="w-1.5 h-1.5 rounded-full bg-emerald-400 animate-pulse-dot" />
                      <span className="text-[6px] text-emerald-300 font-bold">OFFLINE BEREIT</span>
                    </div>
                  </div>
                  {/* Bottom nav */}
                  <div className="h-7 bg-slate-800/80 flex items-center justify-around px-4">
                    <div className="w-3 h-3 rounded bg-white/10" />
                    <div className="w-3 h-3 rounded bg-brand-400/40" />
                    <div className="w-3 h-3 rounded bg-white/10" />
                    <div className="w-3 h-3 rounded bg-white/10" />
                  </div>
                </div>
              </div>
            </div>

            {/* Text content */}
            <div className="flex-1 pt-2">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 text-white/80 text-[11px] font-semibold mb-4 animate-fade-in">
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
                Android Tablet-App
              </div>

              <h1 className="text-3xl font-extrabold text-white mb-3 tracking-tight leading-tight">
                Die Baustelle in<br />
                <span className="bg-gradient-to-r from-amber-300 to-yellow-200 bg-clip-text text-transparent">
                  Ihrer Hosentasche
                </span>
              </h1>

              <p className="text-brand-100 text-[15px] leading-relaxed max-w-md mb-2">
                Zeiterfassung, Bauberichte, Fotos — alles auf dem Tablet.
                <strong className="text-white"> Komplett offline-fähig.</strong> Kein WLAN nötig.
                Daten werden automatisch synchronisiert, sobald Netz verfügbar ist.
              </p>
              <p className="text-brand-200/70 text-xs mb-6">
                Optimiert für Wortmann Terra PAD. Kompatibel mit allen Android-Tablets ab Version 11.
              </p>

              {/* Download buttons */}
              <div className="flex items-center gap-3">
                <a
                  href={downloadUrl}
                  className="inline-flex items-center gap-3 px-7 py-4 rounded-2xl bg-white text-brand-600 font-bold text-sm shadow-xl hover:shadow-2xl hover:scale-[1.02] active:scale-[0.98] transition-all duration-200 group"
                >
                  <svg className="w-6 h-6 group-hover:animate-bounce" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                  APK herunterladen
                </a>
                <button
                  onClick={copyLink}
                  className="inline-flex items-center gap-2 px-5 py-4 rounded-2xl bg-white/15 text-white font-semibold text-sm hover:bg-white/25 transition-all backdrop-blur-sm"
                  title="Download-Link kopieren und an Mitarbeiter senden"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    {copied
                      ? <path d="M5 13l4 4L19 7" />
                      : <><path d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101" /><path d="M10.172 13.828a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" /></>
                    }
                  </svg>
                  {copied ? 'Link kopiert!' : 'Link teilen'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ═══ STATS BAR ═══ */}
      <div className="grid grid-cols-4 gap-4 mb-8">
        {stats.map((s, i) => (
          <div key={s.label} className="sp-card p-4 text-center animate-fade-in" style={{ animationDelay: `${i * 80}ms` }}>
            <div className="text-2xl font-extrabold text-brand-600 mb-0.5">{s.value}</div>
            <div className="text-xs font-semibold text-slate-800">{s.label}</div>
            <div className="text-[10px] text-slate-400">{s.sub}</div>
          </div>
        ))}
      </div>

      {/* ═══ WHY THE APP? ═══ */}
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-5">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-brand-500 to-purple-500 flex items-center justify-center">
            <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <path d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
          <div>
            <h2 className="text-lg font-bold text-slate-900">Warum samoPlan auf dem Tablet?</h2>
            <p className="text-xs text-slate-400">Alles was Ihre Bauarbeiter brauchen — in einer App</p>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {highlights.map((h, i) => (
            <div
              key={h.title}
              className="sp-card p-5 group hover:shadow-lg transition-all duration-300 animate-fade-in"
              style={{ animationDelay: `${200 + i * 80}ms` }}
            >
              <div className="flex items-start gap-4">
                <div className={`w-12 h-12 rounded-2xl ${h.bg} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                  <svg className={`w-6 h-6 ${h.text}`} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    {h.icon}
                  </svg>
                </div>
                <div>
                  <h3 className="text-[14px] font-bold text-slate-900 mb-1">{h.title}</h3>
                  <p className="text-xs text-slate-500 leading-relaxed">{h.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ═══ INSTALLATION GUIDE ═══ */}
      <div className="sp-card p-6 mb-8 animate-fade-in" style={{ animationDelay: '400ms' }}>
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-xl bg-amber-50 flex items-center justify-center">
            <svg className="w-5 h-5 text-amber-500" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
            </svg>
          </div>
          <div>
            <h2 className="text-[15px] font-bold text-slate-900">Installationsanleitung</h2>
            <p className="text-xs text-slate-400">In 4 einfachen Schritten startklar</p>
          </div>
        </div>

        {/* Timeline steps */}
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-[29px] top-4 bottom-4 w-px bg-gradient-to-b from-brand-200 via-brand-100 to-transparent" />

          <div className="space-y-2">
            {steps.map((step, i) => {
              const isOpen = activeStep === i;
              return (
                <div
                  key={step.number}
                  className={`relative rounded-2xl border-2 transition-all duration-300 overflow-hidden cursor-pointer ${
                    isOpen
                      ? 'border-brand-200 bg-brand-50/30 shadow-sm'
                      : 'border-transparent hover:border-surface-100 bg-white'
                  }`}
                  onClick={() => setActiveStep(isOpen ? null : i)}
                >
                  <div className="flex items-center gap-4 p-4">
                    {/* Step circle */}
                    <div className={`relative z-10 w-[58px] h-12 rounded-xl flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                      isOpen
                        ? 'bg-brand-500 shadow-lg shadow-brand-200/50 scale-110'
                        : 'bg-surface-100 hover:bg-surface-200'
                    }`}>
                      <svg className={`w-5 h-5 transition-colors ${isOpen ? 'text-white' : 'text-slate-400'}`} fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                        {step.icon}
                      </svg>
                    </div>

                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2.5">
                        <span className={`text-[10px] font-bold px-2.5 py-0.5 rounded-full transition-colors ${
                          isOpen ? 'bg-brand-100 text-brand-700' : 'bg-surface-100 text-slate-400'
                        }`}>
                          {step.number}
                        </span>
                        <span className="text-[13px] font-bold text-slate-800">{step.title}</span>
                      </div>
                      {!isOpen && <p className="text-[11px] text-slate-400 mt-0.5 truncate">{step.desc}</p>}
                    </div>

                    <svg className={`w-5 h-5 text-slate-300 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>

                  <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`}>
                    <div className="px-4 pb-4 pl-[90px]">
                      <p className="text-xs text-slate-600 leading-relaxed mb-2">{step.desc}</p>
                      {step.tip && (
                        <div className="flex items-start gap-2 p-3 rounded-xl bg-amber-50 border border-amber-100">
                          <svg className="w-4 h-4 text-amber-500 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                          </svg>
                          <span className="text-[11px] text-amber-700 font-medium">{step.tip}</span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* ═══ DEVICES ═══ */}
      <div className="sp-card overflow-hidden mb-8 animate-fade-in" style={{ animationDelay: '500ms' }}>
        <div className="px-6 py-4 border-b border-surface-100 flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-emerald-50 flex items-center justify-center">
            <svg className="w-5 h-5 text-emerald-500" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <path d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
            </svg>
          </div>
          <div>
            <h3 className="text-[14px] font-bold text-slate-800">Kompatible Geräte</h3>
            <p className="text-[11px] text-slate-400">Optimiert für Wortmann Terra PAD — läuft auf allen Android-Tablets</p>
          </div>
        </div>
        <table className="sp-table">
          <thead>
            <tr>
              <th>Gerät</th>
              <th>Display</th>
              <th>Android</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {devices.map((d) => (
              <tr key={d.name}>
                <td className="font-medium text-slate-800 text-xs">{d.name}</td>
                <td className="text-slate-500 text-xs">{d.screen}</td>
                <td className="text-slate-500 text-xs">{d.android}</td>
                <td>
                  <span className={`sp-badge text-[10px] ${
                    d.status === 'Empfohlen'
                      ? 'bg-emerald-50 text-emerald-700 border border-emerald-200'
                      : 'bg-brand-50 text-brand-700 border border-brand-200'
                  }`}>
                    {d.status === 'Empfohlen' && (
                      <svg className="w-3 h-3" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                    )}
                    {d.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ═══ FAQ ═══ */}
      <div className="sp-card p-6 mb-6 animate-fade-in" style={{ animationDelay: '600ms' }}>
        <div className="flex items-center gap-3 mb-5">
          <div className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center">
            <svg className="w-5 h-5 text-slate-500" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <path d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h3 className="text-[14px] font-bold text-slate-800">Häufige Fragen</h3>
        </div>
        <div className="space-y-2.5">
          <FaqItem
            q="Warum nicht über den Google Play Store?"
            a="samoPlan ist Spezialsoftware für Handwerksbetriebe und wird direkt an unsere Kunden ausgeliefert. So können wir Updates schneller bereitstellen, die App exakt auf Ihre Geräte optimieren und sind unabhängig von Googles Richtlinien."
          />
          <FaqItem
            q="Ist die Installation sicher?"
            a="Ja. Die APK wird direkt von unserem Server (samoplan.de) über eine verschlüsselte Verbindung (HTTPS/TLS) geladen. Die App kommuniziert ausschließlich mit unseren DSGVO-konformen Servern in Deutschland."
          />
          <FaqItem
            q="Was ist, wenn kein Internet verfügbar ist?"
            a="Die App funktioniert komplett offline. Zeiteinträge, Fotos, Bauberichte — alles wird lokal auf dem Tablet gespeichert. Sobald wieder eine Internetverbindung besteht, werden die Daten automatisch ins Büro synchronisiert. Kein Datenverlust möglich."
          />
          <FaqItem
            q="Wie bekommt mein Mitarbeiter Zugangsdaten?"
            a="Legen Sie den Mitarbeiter im Büro unter Einstellungen → Nutzer an (Rolle: Bauarbeiter). Geben Sie ihm dann E-Mail und Passwort — fertig. Die App zeigt nach dem Login automatisch die zugewiesenen Projekte."
          />
          <FaqItem
            q="Was passiert bei einem Update?"
            a="Bei neuen Versionen informieren wir Sie per E-Mail. Laden Sie einfach die neue APK herunter und installieren Sie sie — Ihre Daten bleiben selbstverständlich erhalten."
          />
        </div>
      </div>

      {/* ═══ CTA FOOTER ═══ */}
      <div className="sp-card overflow-hidden animate-fade-in" style={{ animationDelay: '700ms' }}>
        <div className="bg-gradient-to-r from-brand-500 to-purple-600 p-6 flex items-center justify-between">
          <div>
            <h3 className="text-white font-bold text-[15px] mb-1">Bereit für die digitale Baustelle?</h3>
            <p className="text-brand-100 text-xs">Laden Sie die App herunter und starten Sie in wenigen Minuten.</p>
          </div>
          <a
            href={downloadUrl}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-white text-brand-600 font-bold text-sm shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] transition-all flex-shrink-0"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
              <path d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            Jetzt herunterladen
          </a>
        </div>
      </div>
    </div>
  );
}

function FaqItem({ q, a }: { q: string; a: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div
      className={`rounded-xl border-2 transition-all duration-200 cursor-pointer ${
        open ? 'border-brand-200 bg-brand-50/20' : 'border-surface-100 hover:border-surface-200'
      }`}
      onClick={() => setOpen(!open)}
    >
      <div className="flex items-center justify-between p-3.5">
        <span className="text-xs font-semibold text-slate-700">{q}</span>
        <svg className={`w-4 h-4 text-slate-300 transition-transform duration-200 flex-shrink-0 ml-3 ${open ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
      <div className={`overflow-hidden transition-all duration-200 ${open ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`}>
        <p className="px-3.5 pb-3.5 text-[11px] text-slate-500 leading-relaxed">{a}</p>
      </div>
    </div>
  );
}
